<!-- <footer class="footer-container-wrapper">
    <div class="container">
        <div class="row">
            <div class="col-12 col-md footer-logo">
              <a href="https://www.bajajcapital.com/">
                <picture>
                <source srcset="assets/images/logo-bajaj-capital.webp" type="image/webp">
                <img src="assets/images/logo-bajaj-capital.png" width="200" alt="logo">
              </picture>
              </a>

              
                <p>{{desc}}</p>
            </div>

            <div class="col-12 col-md footer-nav">
                <h4>Offering</h4>
                <ul>
                    <ng-container *ngFor="let rows of menuLinks">
                        <li *ngIf="rows.type=='offering'">
                            <ng-container *ngIf="rows.link.indexOf('/')==0">


                                <a href="https://www.bajajcapital.com{{rows.link}}" target="_blank"
                                    (click)="registerGAFooter(rows.name)">{{rows.name}}</a>
                            </ng-container>
                            <ng-container *ngIf="rows.link.indexOf('/')!=0">
                                <a href="{{rows.link}}" target="{{rows.target}}"
                                    (click)="registerGAFooter(rows.name)">{{rows.name}}</a>
                            </ng-container>
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div class="col-12 col-md footer-nav">
                <h4>Calculators</h4>
                <ul>
                    <ng-container *ngFor="let rows of menuLinks">
                        <li *ngIf="rows.type=='calculators'">
                            <ng-container *ngIf="rows.link.indexOf('/')==0">
                                <a href="https://www.bajajcapital.com{{rows.link}}" target="_blank"
                                    (click)="registerGAFooter(rows.name)">{{rows.name}}</a>
                            </ng-container>
                            <ng-container *ngIf="rows.link.indexOf('/')!=0">
                                <a href="{{rows.link}}" target="{{rows.target}}"
                                    (click)="registerGAFooter(rows.name)">{{rows.name}}</a>
                            </ng-container>
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div class="col-12 col-md footer-nav">
                <h4>Resources</h4>
                <ul>
                    <ng-container *ngFor="let menu of menuLinks">
                        <li *ngIf="menu.type=='resources'">
                            <ng-container *ngIf="menu.link.indexOf('/')==0">
                                <a href="https://www.bajajcapital.com{{menu.link}}" target="_blank"
                                    (click)="registerGAFooter(menu.name)">{{menu.name}}</a>
                            </ng-container>
                            <ng-container *ngIf="menu.link.indexOf('/')!=0">
                                <a href="{{menu.link}}" target="{{menu.target}}"
                                    (click)="registerGAFooter(menu.name)">{{menu.name}}</a>
                            </ng-container>
                        </li>
                    </ng-container>
                </ul>
            </div>
            <div class="col-12 col-md updated">
                <h4>Contact</h4>
                <a href="tel:{{tollfree}}">
                    <span class="material-icons-outlined">
                        phone
                    </span>
                    <span> {{tollfree}} </span> 
                </a>
                <span *ngIf="display_tollfree_sec"><br /><a href="tel:{{tollfree_2}}">
                        <span class="material-icons-outlined">
                            phone
                        </span>
                        <span> {{tollfree_2}}
                        </span> </a></span>
                <span [innerHTML]="contactLinks"></span>
            </div>
        </div>
    </div>
    <div class="footer-bottom-pane">
        <div class="container">
            <div class="row">
                <div class="col-md-5">
                    <p class="copyright">
                        Copyright &copy; 2020 BajajCapital Limited
                    </p>
                </div>

                <div class="col-md-7">
                    <ul class="bottom-pane-links">
                        <li><a [routerLink]="['/term-conditions']" [queryParams]="{doc:'legal_disclaimer'}"
                                (click)="registerGAFooter_PolicyDoc('Legal Disclaimer')">Legal Disclaimer</a></li>
                        <li><a [routerLink]="['/term-conditions']" [queryParams]="{doc:'privacy_policy'}"
                                (click)="registerGAFooter_PolicyDoc('Privacy Policy')">Privacy Policy</a></li>
                        <li><a [routerLink]="['/term-conditions']" [queryParams]="{doc:'tnc'}"
                                (click)="registerGAFooter_PolicyDoc('Terms and Conditions')">Terms and Conditions</a>
                        </li>

                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer> -->




<footer class="footer-container-wrapper">
    <div class="container">
      <div class="row">
        <!-- Footer Logo and Description -->
        <div class="col-12 col-md footer-logo">
          <a href="https://www.bajajcapital.com/">
            <picture>
            <source srcset="assets/images/logo-bajaj-capital.webp" type="image/webp">
            <img src="assets/images/logo-bajaj-capital.png" width="200" height="39" alt="Bajaj Capital Logo">
          </picture>
          </a>
          <p>
            BajajCapital is India’s premier investment services group engaged inter-alia in the distribution of mutual funds, insurance, fixed deposits, bonds, loans, etc.
          </p>
        </div>
  
        <!-- Offerings Section -->
        <div class="col-12 col-md footer-nav">
          <h4>Offering</h4>
          <ul>
            <li><a href="https://my.bajajcapital.com/" target="_blank">Mutual Funds</a></li>
            <li><a href="https://www.bajajcapitalinsurance.com/" target="_blank">Insurance</a></li>
            <li><a href="https://www.bajajcapital.com/bonds" target="_blank">Bonds</a></li>
            <li><a href="https://nps.bajajcapital.com/" target="_blank">National Pension Scheme</a></li>
            <li><a href="https://fd.bajajcapital.com/" target="_blank">Fixed Deposits</a></li>
            <li><a href="https://www.bajajcapital.com/beautiful-minds" target="_blank">Exclusively for Women</a></li>
            <li><a href="https://www.bajajcapital.com/mutual-fund/mf-amc" target="_blank">AMC for Investments</a></li>
            <li><a href="https://pos.bajajcapitalinsurance.com/" target="_blank">Partner With Us</a></li>
            <li><a href="https://www.bajajcapitalrealty.com" target="_blank">Invest in Real Estate</a></li>
          </ul>
        </div>
  
        <!-- Calculators Section -->
        <div class="col-12 col-md footer-nav">
          <h4>Calculators</h4>
          <ul>
            <li><a href="https://www.bajajcapital.com/financial-calculators/sip-planner" target="_blank">Systematic Investment Planner</a></li>
            <li><a href="https://www.bajajcapitalone.com/loans/home-loan/campaign/002/apply-now.html#EMICalculator" target="_blank">Home Loan EMI</a></li>
            <li><a href="https://nps.bajajcapital.com/#EMICalculator" target="_blank">Pension</a></li>
            <li><a href="https://www.bajajcapital.com/financial-calculators/marriage-planner-calculator" target="_blank">Child Marriage Planner</a></li>
            <li><a href="https://www.bajajcapital.com/financial-calculators/maturity-calculator" target="_blank">Maturity Amount</a></li>
            <li><a href="https://www.bajajcapital.com/financial-calculators/human-life-value-calculator" target="_blank">Human Life Value</a></li>
            <li><a href="https://www.bajajcapital.com/financial-calculators/gratuity-calculator" target="_blank">Gratuity</a></li>
            <li><a href="https://www.bajajcapital.com/tax-saving-solutions" target="_blank">Tax Saving</a></li>
            <li><a href="https://www.bajajcapital.com/retirement-planning" target="_blank">Retirement Planning</a></li>
            <li><a href="https://www.bajajcapital.com/financial-calculators/crorepati-calculator" target="_blank">Crorepati Calculator</a></li>
          </ul>
        </div>
  
        <!-- Resources Section -->
        <div class="col-12 col-md footer-nav">
          <h4>Resources</h4>
          <ul>
            <li><a href="https://www.bajajcapital.com/about-us" target="_blank">About Us</a></li>
            <li><a href="https://www.bajajcapital.com/our-new-identity.html" target="_blank">New Brand Identity</a></li>
            <li><a href="https://www.bajajcapital.com/rm-assistance" target="_blank">RM Assistance</a></li>
            <li><a href="https://www.bajajcapital.com/help-centre#branch" target="_blank">Branch Locator</a></li>
            <li><a href="https://www.bajajcapital.com/careers" target="_blank">Careers</a></li>
            <li><a href="https://www.bajajcapital.com/customer-reviews" target="_blank">Customer Testimonials</a></li>
            <li><a href="https://www.bajajcapital.com/help-centre" target="_blank">Help Centre</a></li>
            <li><a href="https://www.bajajcapital.com/blog" target="_blank">Blog</a></li>
            <li><a href="https://www.bajajcapital.com/dpservices/dp-service" target="_blank">DP Services</a></li>
            <li><a href="https://www.bajajcapital.com/assets/social-media-policy.pdf" target="_blank">Other Policies</a></li>
            <li><a href="https://www.bajajcapital.com/research/knowledge-series" target="_blank">Information Centre</a></li>
            <li><a href="https://www.bajajcapital.com/publication-archive" target="_blank">Publications</a></li>
            <li><a href="https://www.bajajcapital.com/about-us/ceo-bajaj-capital" target="_blank">CEO Bajaj Capital Insurance</a></li>
            <li><a href="https://www.bajajcapital.com/about-us/deputy-ceo-wealth-bajaj-capital" target="_blank">CEO Bajaj Capital Wealth</a></li>
          </ul>
        </div>
  
        <!-- Contact Section -->
        <div class="col-12 col-md updated">
          <h4>Contact</h4>
          <a href="tel:1800-313-123123">
            <span class="material-icons-outlined">phone</span>
            <span>1800-313-123123</span>
          </a>
          <p>Mon - Sat (10 AM - 6 PM)</p>
          <p>In case of any queries, feel free to call or write to us. We will be very happy to assist you.</p>
          <p>contactus@bajajcapital.com</p>
          <ul class="social-links">
            <li><a href="https://www.facebook.com/bajajcapital" target="_blank"><img alt="facebook" src="assets/images/facebook-icon.png" width="24" height="24"></a></li>
            <li><a href="https://twitter.com/mybajajcapital" target="_blank"><img alt="twitter" src="assets/images/x-logo.png" width="24" height="24"></a></li>
            <li><a href="https://www.linkedin.com/company/bajaj-capital-ltd" target="_blank"><img alt="linkedin" src="assets/images/linkden-icon.png" width="24" height="24"></a></li>
            <li><a href="https://instagram.com/bajaj_capital" target="_blank"><img alt="instagram" src="assets/images/instagram.png" width="24" height="24"></a></li>
            <li><a href="https://www.youtube.com/channel/UCHd387ggvz3JC7I9wVtPhtw" target="_blank"><img alt="youtube" src="assets/images/youtube-icon.png" width="24" height="24"></a></li>
          </ul>
        </div>
      </div>
    </div>

    <div _ngcontent-ng-c4025223604="" class="footer-bottom-pane">
        <div _ngcontent-ng-c4025223604="" class="container">
          <div _ngcontent-ng-c4025223604="" class="row">
            <div _ngcontent-ng-c4025223604="" class="col-md-5">
              <p _ngcontent-ng-c4025223604="" class="copyright">
                Copyright © 2020 BajajCapital Limited
              </p>
            </div>
            <div _ngcontent-ng-c4025223604="" class="col-md-7">
              <ul _ngcontent-ng-c4025223604="" class="bottom-pane-links">
                <li _ngcontent-ng-c4025223604="">
                  <a _ngcontent-ng-c4025223604="" ng-reflect-router-link="/term-conditions" ng-reflect-query-params="[object Object]" href="/term-conditions?doc=legal_disclaimer">Legal Disclaimer</a>
                </li>
                <li _ngcontent-ng-c4025223604="">
                  <a _ngcontent-ng-c4025223604="" ng-reflect-router-link="/term-conditions" ng-reflect-query-params="[object Object]" href="/term-conditions?doc=privacy_policy">Privacy Policy</a>
                </li>
                <li _ngcontent-ng-c4025223604="">
                  <a _ngcontent-ng-c4025223604="" ng-reflect-router-link="/term-conditions" ng-reflect-query-params="[object Object]" href="/term-conditions?doc=tnc">Terms and Conditions</a>
                </li>
                <li _ngcontent-ng-c4025223604="">
                  <a _ngcontent-ng-c4025223604="" ng-reflect-router-link="/term-conditions" ng-reflect-query-params="[object Object]" href="/term-conditions?doc=disclaimer">Disclaimer</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
  </footer>